import { touchAdminSessionActivity } from "./adminSessionActivity";

/** sessionStorage key for the email used at login (set after OTP success until sign-out). */
export const ADMIN_SESSION_EMAIL_KEY = "ns-admin-session-email";

const listeners = new Set<() => void>();

export function subscribeAdminSessionEmail(listener: () => void): () => void {
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
  };
}

function notifyListeners(): void {
  listeners.forEach((listener) => listener());
}

export function getAdminSessionEmail(): string {
  try {
    return sessionStorage.getItem(ADMIN_SESSION_EMAIL_KEY)?.trim() ?? "";
  } catch {
    return "";
  }
}

export function setAdminSessionEmail(email: string): void {
  const value = email.trim();
  if (!value) {
    return;
  }
  try {
    sessionStorage.setItem(ADMIN_SESSION_EMAIL_KEY, value);
  } catch {
    /* private mode / quota */
  }
  touchAdminSessionActivity();
  notifyListeners();
}

export function clearAdminSessionEmail(): void {
  try {
    sessionStorage.removeItem(ADMIN_SESSION_EMAIL_KEY);
  } catch {
    /* noop */
  }
  notifyListeners();
}

export function hasAdminSession(): boolean {
  return getAdminSessionEmail().length > 0;
}
